import { Button } from "antd";
import "./DrawerFooter.css";

interface DataType {
  id: string;
  name: string;
  imageUrl: string;
  countOfSong: number;
  region: string;
  fileName: string;
  publishedSongs: number;
}
interface DrawerFooterProps {
  handleSubmit?: () => void;
  handleCancel: () => void;
  handleDelete?: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  isDeleteLoading?: boolean;
  cancelButtonText?: string;
  submitButtonText?: string;
}

const DrawerFooter = ({
  handleSubmit,
  handleCancel,
  handleDelete,
  disabled,
  isLoading,
  isDeleteLoading,
  cancelButtonText,
  submitButtonText,
}: DrawerFooterProps) => {
  return (
    <div
      className="drawer-footer-container"
      style={!handleDelete ? { justifyContent: "flex-end" } : undefined}
    >
      {handleDelete && (
        <Button
          danger
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
          }}
          onClick={() => {
            if (handleDelete) handleDelete();
          }}
          loading={isDeleteLoading}
        >
          <img
            alt="delete icon"
            src={require("../../../assets/icons/delete-icon.png")}
            style={{ width: 16, height: 16, marginRight: 10 }}
          />
          Delete
        </Button>
      )}

      <div>
        <Button onClick={handleCancel}>
          {cancelButtonText ? cancelButtonText : "Cancel"}
        </Button>
        <Button
          type="primary"
          style={{ marginLeft: 8, textAlign: "center" }}
          htmlType="submit"
          disabled={disabled || isLoading}
          loading={isLoading}
          onClick={() => {
            if (handleSubmit) {
              handleSubmit();
            }
          }}
        >
          {submitButtonText ? submitButtonText : "Submit"}
        </Button>
      </div>
    </div>
  );
};

export default DrawerFooter;
